export default "<ion-app>\n  <ion-router-outlet></ion-router-outlet>\n  <app-menu></app-menu>\n</ion-app>";